import {
  call,
  put,
  takeLatest,
  // select,
} from 'redux-saga/effects';
import { get } from 'lodash';
import { message } from 'antd';
import { getLandingPage, setLandingPage } from '@api/landingPage';
import * as types from './types';

// eslint-disable-next-line arrow-parens
const displayError = err => {
  const error = get(err, 'response.data.message', 'Unknown Error');
  message.error(error);
};

function* retrieve(action) {
  try {
    const resp = yield call(getLandingPage, action.payload);
    const { data } = resp;
    yield put({
      type: types.UPDATE_DEFAULT_LANDING_PAGE,
      payload: data,
    });
  } catch (err) {
    displayError(err);
  }
}

function* setPage(action) {
  try {
    const { payload } = action;
    yield call(setLandingPage, payload);
    yield put({
      type: types.UPDATE_DEFAULT_LANDING_PAGE,
      payload,
    });
    let msg = '';
    if (payload.url === '') {
      msg = 'You have successfully delete your default dashboard.';
    } else {
      msg = 'You have successfully set your default dashboard.';
    }
    message.success(msg);
  } catch (err) {
    displayError(err);
  }
}

const watchMap = {
  [types.INIT]: retrieve,
  [types.SET_DEFAULT_LANDING_PAGE]: setPage,
};
function* watch() {
  // eslint-disable-next-line no-restricted-syntax
  for (const [type, func] of Object.entries(watchMap)) {
    yield takeLatest([type], func);
  }
}

export default [watch];
